import DetailContent from "./DetailContent";
export default DetailContent;
